import { render, staticRenderFns } from "./WorkspaceAI.vue?vue&type=template&id=2402bca6&scoped=true&"
import script from "./WorkspaceAI.vue?vue&type=script&lang=js&"
export * from "./WorkspaceAI.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceAI.vue?vue&type=style&index=0&id=2402bca6&prod&lang=css&"
import style1 from "./WorkspaceAI.vue?vue&type=style&index=1&id=2402bca6&prod&scoped=true&lang=css&"
import style2 from "./WorkspaceAI.vue?vue&type=style&index=2&id=2402bca6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2402bca6",
  null
  
)

export default component.exports